/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCreateRequestItemsSchema } from "./banquetCreateRequestItemsSchema.ts";
import { kindEnumSchema } from "./kindEnumSchema.ts";

export const deliveryOrderCreateRequestSchema = z.object({
	address_id: z.uuid().optional().describe("Сохранённый адрес гостя вместо полей адреса."),
	city: z.string().max(60).optional(),
	entrance: z.string().max(10).optional(),
	line1: z.string().max(250).optional(),
	latitude: z.number().nullish(),
	longitude: z.number().nullish(),
	kind: kindEnumSchema.describe("* `courier` - Доставка курьером\n* `pickup` - Самовывоз"),
	items: z.array(banquetCreateRequestItemsSchema).optional().describe("Позиции в том же формате, что при создании обычного заказа."),
	combos: z.array(banquetCreateRequestItemsSchema).optional().describe("Комбо в том же формате, что при создании обычного заказа."),
	promo_code: z.string().min(1).optional(),
	flat: z.string().max(10).optional(),
	floor: z.string().max(10).optional(),
	doorphone: z.string().max(10).optional(),
	address_comment: z.string().max(500).optional(),
	delivery_time: z.iso.datetime().nullish().describe("Ко времени, в местном времени точки (значение из слотов); пусто — как можно скорее."),
	comment: z.string().max(500).optional(),
	persons: z.int().min(1).max(50).optional().default(1),
});
